import { render } from "./Edit.vue?vue&type=template&id=3e741a3f"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=3e741a3f&lang=postcss"
script.render = render

export default script